

























import Vue from "vue"
export default Vue.extend({
  props: {
    hasRadius: {
      type: Boolean,
      default: false,
    },
    isWhiteBackground: {
      type: Boolean,
      default: false,
    },
    isClickable: {
      type: Boolean,
      default: false,
    },
  },
})
